import { render } from "./ChapterForm.vue?vue&type=template&id=0760eb04"
import script from "./ChapterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/chapter/ChapterForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0760eb04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0760eb04', __exports__)) {
    api.reload('0760eb04', __exports__)
  }
  
  module.hot.accept("./ChapterForm.vue?vue&type=template&id=0760eb04", () => {
    api.rerender('0760eb04', render)
  })

}


export default __exports__